<mat-tab-group animationDuration="0ms" mat-stretch-tabs="false" mat-align-tabs="center"
  [selectedIndex]="activeTabIndex()" (selectedIndexChange)="onTabChange($event)">
  <mat-tab [label]="'ADMIN.CLIENT_HOURS.TAB_LOGGED_TIME' | translate">
    <app-client-hours />
  </mat-tab>

  <mat-tab *appIfHasPermission="['viewAdmin.viewReports.viewNotificationManagement']"
    [label]="'ADMIN.CLIENT_HOURS.TAB_NOTIFICATION_MANAGEMENT' | translate">
    @if (showNotificationManagement()) {
      <app-notification-management />
    }
  </mat-tab>
</mat-tab-group>